// This is a singleton instance to manage the current active id

import { getStore } from '../App';
import { getMySingleDoctorId } from '../store/idbHandler';
import { getActiveDoctorId, getMActiveId, setMActiveId } from '../store/localstorage';
import { GlobalState } from '../store/reducers';

// helps in knowing if the user is changed / switched in another tab, i.e auth JWT is changed
let mActiveId = getMActiveId();

export const getCurrentMActiveId = (): string | undefined => {
    // use the one cached in the memory at the init of the page
    return mActiveId;
};

export const setCurrentActiveId = (id?: string): void => {
    setMActiveId(id);
    mActiveId = getMActiveId();
};

export const getMyIdWithBackwardCompatibility = (): string | undefined => {
    return getActiveDoctorId() || getCurrentMActiveId();
};

/**
 * @deprecated
 * There is no use case of this function
 * Either it's the docid or the mActiveId
 */
export const getMyDbId = (): string | undefined => {
    // if it's a doctor persona
    // activeId === docid which gives us backward compatibility
    return (
        (getStore().getState() as GlobalState).prescriptionPad?.prescription?.doctor._id ||
        getActiveDoctorId() ||
        mActiveId
    );
};

export const getDocIdForMdb = (): string | undefined => {
    return (
        (getStore().getState() as GlobalState).prescriptionPad?.prescription?.doctor._id ||
        getActiveDoctorId() ||
        getMySingleDoctorId() ||
        mActiveId
    );
};
